export default __webpack_public_path__ + "static/media/hht2_ep13_book_wp_01.116ba0c4.jpg";